import { StaticImageData } from 'next/image'

export enum TechWeBuildOnTiWinId {
  Frontend = 'Frontend',
  Mobile = 'Mobile',
  Backend = 'Backend',
  InfrastructureDevOps = 'Infrastructure & DevOps',
  RealTimeMessaging = 'Real-Time & Messaging',
  Databases = 'Databases',
  AiMl = 'AI / ML',
  BlockchainWeb3 = 'Blockchain / Web3',
  DesignPrototyping = 'Design & Prototyping',
  Monitoring = 'Monitoring',
}

export type Technology = {
  id: string
  title: string
  logo: StaticImageData
}

export type TechWeBuildOnTiWinItem = {
  id: TechWeBuildOnTiWinId
  title: string
  technologies: Technology[]
}
